import { transition, trigger, useAnimation } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { AnimationLib } from 'src/app/shared/libraries/animations/animation-lib';
import { NotificationModel } from '../../notification.model';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('show', [
      transition(':enter', [
        useAnimation(AnimationLib.fadeIn, {
          params: {
            duration: 300
          }
        })
      ])
    ])
  ]
})
export class NotificationComponent implements OnInit {
  
  
  @Input()
  notification: NotificationModel;

  @Output()
  closeClick = new EventEmitter<{ action: string, data: any}>();

  constructor(
  ) { }

  ngOnInit() {
    
  }

  handleActionClick() {
    this.close(this.notification.action);
  }

  handleCloseClick() {
    this.close();
  }

  private close(action: string = '') {
    this.notification = null;
    this.closeClick.emit({
      action: action,
      data: this.notification
    });
  }
}
